import React from "react";
import { useTranslation } from "react-i18next";

const MobilePreviewComponent = (props) => {
  const { t } = useTranslation("dashboard");
  const { brandingColor, theme, isDefaultColor, secondaryTextColor } = props;

  const primaryColor =
    brandingColor && !isDefaultColor ? brandingColor : "#5BC500";
  const bgColor = theme === "light" ? "#F2F2F2" : "#181818";
  const elevationOne =
    theme === "light" ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)";
  const elevationTwo =
    theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)";
  const textHigh =
    theme === "light" ? "rgba(0, 0, 0, 0.87)" : "rgba(255, 255, 255, 0.87)";
  const textMid =
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)";
  const textLow =
    theme === "light" ? "rgba(0, 0, 0, 0.38)" : "rgba(255, 255, 255, 0.38)";
  const textColor = secondaryTextColor || "#FFFFFF";

  return (
    <svg
      className="mobile-app-preview"
      xmlns="http://www.w3.org/2000/svg"
      width={360}
      height={760}
      viewBox="0 0 360 760"
    >
      <defs>
        <filter
          id="prefix__b"
          x={-19}
          y={245}
          width={403}
          height={98}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={16} result="blur" />
          <feFlood floodOpacity={0.141} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="prefix__c"
          x={-24}
          y={245}
          width={406}
          height={98}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={16} result="blur-2" />
          <feFlood floodOpacity={0.141} />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="prefix__d"
          x={-31}
          y={300.125}
          width={120}
          height={120}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={16} result="blur-3" />
          <feFlood floodOpacity={0.141} />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="prefix__e"
          x={-105}
          y={505}
          width={246}
          height={243}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy={6} />
          <feGaussianBlur stdDeviation={35} result="blur-4" />
          <feFlood floodColor={textColor} floodOpacity={0.102} />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="prefix__f"
          x={-31}
          y={526}
          width={120}
          height={120}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={16} result="blur-5" />
          <feFlood floodOpacity={0.141} />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
        <clipPath id="prefix__a">
          <path d="M0 0h360v760H0z" />
        </clipPath>
      </defs>
      <g data-name="Calendar - day view test color" clipPath="url(#prefix__a)">
        <path fill={bgColor} d="M0 0h360v760H0z" />
        <rect
          data-name="Rectangle 3"
          width={345}
          height={116}
          rx={5}
          transform="translate(8 88)"
          fill={elevationOne}
        />
        <path
          data-name="Rectangle 2"
          d="M0 24h360v51a5 5 0 01-5 5H5a5 5 0 01-5-5V24z"
          fill={elevationOne}
        />
        <text
          transform="translate(16 59)"
          fill={textHigh}
          fontSize={20}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={0} y={0}>
            {t("mobilePreview.calendar")}
          </tspan>
        </text>
        <path data-name="Base copy 9" fill="none" d="M264 36h40v32h-40z" />
        <text
          transform="translate(284 57)"
          fill="#cbcbcb"
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-19.178} y={0}>
            {t("mobilePreview.month")}
          </tspan>
        </text>
        <path data-name="Base copy 9" fill="none" d="M304 36h40v32h-40z" />
        <path
          data-name="MENU copy 2"
          fill={elevationOne}
          d="M8 212h344v120H8z"
        />
        <g filter="url(#prefix__b)">
          <rect
            data-name="MENU copy 3"
            width={307}
            height={2}
            rx={1}
            transform="translate(29 293)"
            fill={textLow}
          />
        </g>
        <text
          data-name="Off-season phase"
          transform="translate(23.747 258.164)"
          fill={textHigh}
          fontSize={11}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {t("mobilePreview.offSeasonPhase")}
          </tspan>
        </text>
        <text
          transform="translate(23.747 283.348)"
          fill={textLow}
          fontSize={11}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {t("mobilePreview.progress")}
          </tspan>
        </text>
        <text
          data-name="100% Completed"
          transform="translate(252.41 309.486)"
          fill={textHigh}
          fontSize={11}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {t("mobilePreview.percentCompleted")}
          </tspan>
        </text>
        <path
          data-name="MENU copy 84"
          fill={elevationOne}
          d="M8 340h344v218H8z"
        />
        <rect
          data-name="Rectangle 4 copy 35"
          width={66}
          height={24}
          rx={12}
          transform="translate(54 348)"
          fill={elevationTwo}
        />
        <text
          transform="translate(61.978 365.355)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={0} y={0}>
            {"Squat"}
          </tspan>
        </text>
        <path
          d="M342.81 530.191l-4.852-4.852a1.145 1.145 0 00-1.625 1.613l4.051 4.051-4.051 4.052a1.145 1.145 0 001.625 1.614l4.852-4.852a1.144 1.144 0 000-1.625z"
          fill={textHigh}
        />
        <text
          data-name="5x1 Reps @ RPE7 @ 125kg (75%)"
          transform="translate(67 399)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={0} y={0}>
            {"5x1 Reps @ RPE7 @ 125kg (75%)"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 442)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 459)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 476)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 493)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 510)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          transform="translate(172 423)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-13.951} y={0}>
            {t("mobilePreview.reps")}
          </tspan>
        </text>
        <text
          transform="translate(237 423)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-10.875} y={0}>
            {t("mobilePreview.rpe")}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 442)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 459)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 476)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 493)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 510)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          transform="translate(295 423)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-14.136} y={0}>
            {t("mobilePreview.load")}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 442)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 459)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 476)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 493)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 510)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(129 441)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name="#"
          transform="translate(129 423)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"#"}
          </tspan>
        </text>
        <text
          data-name={2}
          transform="translate(129 457)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"2"}
          </tspan>
        </text>
        <text
          data-name={3}
          transform="translate(129 474)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"3"}
          </tspan>
        </text>
        <text
          data-name={4}
          transform="translate(129 491)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"4"}
          </tspan>
        </text>
        <text
          data-name={5}
          transform="translate(129 509)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"5"}
          </tspan>
        </text>
        <path
          data-name="Line 20"
          d="M313.5 406H57.046v-1H313.5z"
          fill={elevationTwo}
        />
        <path
          d="M329.824 434.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046z"
          fill="#5bc500"
        />
        <path
          data-name="check"
          d="M329.824 451.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046zM329.824 487.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046zM329.824 503.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046z"
          fill="#5bc500"
        />
        <path
          d="M324.677 471.667a.667.667 0 00-.667.667v4a.667.667 0 001.333 0v-4a.667.667 0 00-.666-.667zm0-2.667a.833.833 0 10.833.833.833.833 0 00-.833-.833z"
          fill="#ed0a34"
        />
        <path
          data-name="MENU copy 84"
          fill={elevationOne}
          d="M8 566h344v218H8z"
        />
        <rect
          data-name="Rectangle 4 copy 35"
          width={66}
          height={24}
          rx={12}
          transform="translate(54 574)"
          fill={elevationTwo}
        />
        <text
          data-name="Bench"
          transform="translate(61.978 591.355)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={0} y={0}>
            {t("workout.bench")}
          </tspan>
        </text>
        <path
          data-name="angle-right"
          d="M342.81 756.191l-4.852-4.852a1.145 1.145 0 00-1.625 1.613l4.051 4.051-4.051 4.052a1.145 1.145 0 001.625 1.614l4.852-4.852a1.144 1.144 0 000-1.625z"
          fill={textHigh}
        />
        <text
          data-name="5x1 Reps @ RPE7 @ 125kg (75%)"
          transform="translate(67 625)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={0} y={0}>
            {"5x1 Reps @ RPE7 @ 125kg (75%)"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 668)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 685)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 702)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 719)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(172 736)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name="Reps"
          transform="translate(172 649)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-13.951} y={0}>
            {t("mobilePreview.reps")}
          </tspan>
        </text>
        <text
          data-name="RPE"
          transform="translate(237 649)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-10.875} y={0}>
            {t("mobilePreview.rpe")}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 668)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 685)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 702)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 719)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name={7}
          transform="translate(237 736)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-3.425} y={0}>
            {"7"}
          </tspan>
        </text>
        <text
          data-name="Load"
          transform="translate(295 649)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-14.136} y={0}>
            {t("mobilePreview.load")}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 668)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 685)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 702)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 719)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name="125kg"
          transform="translate(295 736)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-17.042} y={0}>
            {"125kg"}
          </tspan>
        </text>
        <text
          data-name={1}
          transform="translate(129 667)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"1"}
          </tspan>
        </text>
        <text
          data-name="#"
          transform="translate(129 649)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"#"}
          </tspan>
        </text>
        <text
          data-name={2}
          transform="translate(129 683)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"2"}
          </tspan>
        </text>
        <text
          data-name={3}
          transform="translate(129 700)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"3"}
          </tspan>
        </text>
        <text
          data-name={4}
          transform="translate(129 717)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"4"}
          </tspan>
        </text>
        <text
          data-name={5}
          transform="translate(129 735)"
          fill={textLow}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {"5"}
          </tspan>
        </text>
        <path
          data-name="Line 20"
          d="M313.5 632H57.046v-1H313.5z"
          fill={elevationTwo}
        />
        <path
          data-name="check"
          d="M329.824 660.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046zM329.824 677.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046z"
          fill="#5bc500"
        />
        <path
          data-name="check"
          d="M329.824 713.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046zM329.824 729.211a.712.712 0 00-1.01 0l-5.3 5.308-2.229-2.233a.727.727 0 00-1.01 1.045l2.732 2.732a.712.712 0 001.01 0l5.806-5.806a.712.712 0 000-1.046z"
          fill="#00c59d"
        />
        <path
          data-name="info"
          d="M324.677 697.667a.667.667 0 00-.667.667v4a.667.667 0 001.333 0v-4a.667.667 0 00-.666-.667zm0-2.667a.833.833 0 10.833.833.833.833 0 00-.833-.833z"
          fill="#ed0a34"
        />
        <text
          transform="translate(26 142.394)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={-10.433} y={0}>
            {"MO"}
          </tspan>
        </text>
        <text
          data-name={16}
          transform="translate(26 170.813)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-6.85} y={0}>
            {"16"}
          </tspan>
        </text>
        <text
          transform="translate(76 142.899)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={-8.01} y={0}>
            {"TU"}
          </tspan>
        </text>
        <text
          data-name={17}
          transform="translate(76 171.318)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-6.85} y={0}>
            {"17"}
          </tspan>
        </text>
        <text
          transform="translate(126 142.899)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={-9.161} y={0}>
            {"WE"}
          </tspan>
        </text>
        <text
          data-name={18}
          transform="translate(126 171.318)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-6.85} y={0}>
            {"18"}
          </tspan>
        </text>
        <text
          transform="translate(236 142.899)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={-7.254} y={0}>
            {"FR"}
          </tspan>
        </text>
        <text
          data-name={20}
          transform="translate(236 171.318)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-6.85} y={0}>
            {"20"}
          </tspan>
        </text>
        <text
          transform="translate(285 141.899)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={-7.444} y={0}>
            {"SA"}
          </tspan>
        </text>
        <text
          data-name={21}
          transform="translate(285 171.318)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-6.85} y={0}>
            {"21"}
          </tspan>
        </text>
        <text
          transform="translate(336 142.899)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={-7.84} y={0}>
            {"SU"}
          </tspan>
        </text>
        <text
          data-name={22}
          transform="translate(336 171.318)"
          fill={textMid}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-6.85} y={0}>
            {"22"}
          </tspan>
        </text>
        <text
          transform="translate(180 142.899)"
          fill={textHigh}
          fontSize={12}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={-8.065} y={0}>
            {"TH"}
          </tspan>
        </text>
        <path
          d="M185.246 190.167a1 1 0 00-1.41 0l-3.59 3.54-3.54-3.54a1 1 0 10-1.41 1.42l4.24 4.24a1 1 0 001.42 0l4.29-4.24a1 1 0 000-1.42z"
          fill={textHigh}
        />
        <path fill={bgColor} d="M0 704h360v56H0z" />
        <path
          d="M318.274 729.638a5.4 5.4 0 10-6.674 0 8.995 8.995 0 00-5.595 7.358.906.906 0 101.8.2 7.2 7.2 0 0114.3 0 .9.9 0 00.9.8h.1a.9.9 0 00.791-.991 8.995 8.995 0 00-5.622-7.367zm-3.338-.639a3.6 3.6 0 113.6-3.6 3.6 3.6 0 01-3.6 3.6zM221.999 723.6a.9.9 0 00-.9.9v9a.9.9 0 001.8 0v-9a.9.9 0 00-.9-.9zm-4.5 5.4a.9.9 0 00-.9.9v3.6a.9.9 0 001.8 0v-3.6a.9.9 0 00-.9-.9zm9-1.8a.9.9 0 00-.9.9v5.4a.9.9 0 001.8 0v-5.4a.9.9 0 00-.9-.9zm1.8-7.2h-12.6a2.7 2.7 0 00-2.7 2.7v12.6a2.7 2.7 0 002.7 2.7h12.6a2.7 2.7 0 002.7-2.7v-12.6a2.7 2.7 0 00-2.7-2.7zm.9 15.3a.9.9 0 01-.9.9h-12.6a.9.9 0 01-.9-.9v-12.6a.9.9 0 01.9-.9h12.6a.9.9 0 01.9.9zM134.929 724.097l-2.555-2.555a.9.9 0 00-1.277 1.268l1.907 1.907-7.287 7.287-1.907-1.907a.9.9 0 10-1.268 1.277l2.528 2.53 2.528 2.528a.9.9 0 101.277-1.268l-1.88-1.88 7.286-7.286 1.907 1.906a.9.9 0 101.268-1.28zm-12.387 9.814a.903.903 0 00-1.278 1.277l2.546 2.546a.903.903 0 101.277-1.277zm16.192-11.101l-2.546-2.546a.903.903 0 00-1.277 1.277l2.546 2.546a.903.903 0 101.277-1.277z"
          fill={textLow}
        />
        <path
          data-name="Line 58"
          d="M360 704.5H0v-1h360z"
          fill={elevationTwo}
        />
        <text
          transform="translate(324 57)"
          fill={primaryColor}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-11.101} y={0}>
            {t("mobilePreview.day")}
          </tspan>
        </text>
        <g filter="url(#prefix__c)">
          <rect
            data-name="MENU copy 4"
            width={310}
            height={2}
            rx={1}
            transform="translate(24 293)"
            fill={primaryColor}
          />
        </g>
        <text
          data-name="Strength Training Program"
          transform="translate(23.747 241.202)"
          fill={primaryColor}
          fontSize={11}
          fontFamily="OpenSans-Bold, Open Sans"
          fontWeight={700}
        >
          <tspan x={0} y={0}>
            {t("mobilePreview.strengthTrainingProgram")}
          </tspan>
        </text>
        <g filter="url(#prefix__d)">
          <rect
            data-name="MENU copy 84"
            width={24}
            height={24}
            rx={12}
            transform="translate(17 348.12)"
            fill={primaryColor}
          />
        </g>
        <path
          d="M306 360a2 2 0 102 2 2 2 0 00-2-2zm-7 0a2 2 0 102 2 2 2 0 00-2-2zm14 0a2 2 0 102 2 2 2 0 00-2-2z"
          fill={primaryColor}
        />
        <path
          data-name="MENU copy 84"
          d="M336 353a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z"
          fill={primaryColor}
        />
        <circle
          data-name="Ellipse 33"
          cx={4}
          cy={4}
          r={4}
          transform="translate(55 391)"
          fill={primaryColor}
        />
        <text
          data-name="Actual Results:"
          transform="translate(54 422)"
          fill={primaryColor}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {t("mobilePreview.actualResults")}
          </tspan>
        </text>
        <path
          data-name="ellipsis-h"
          d="M306 586a2 2 0 102 2 2 2 0 00-2-2zm-7 0a2 2 0 102 2 2 2 0 00-2-2zm14 0a2 2 0 102 2 2 2 0 00-2-2z"
          fill={primaryColor}
        />
        <path
          data-name="MENU copy 84"
          d="M336 579a8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8z"
          fill={primaryColor}
        />
        <text
          data-name="Actual Results:"
          transform="translate(54 648)"
          fill={primaryColor}
          fontSize={8}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={0} y={0}>
            {t("mobilePreview.actualResults")}
          </tspan>
        </text>
        <g filter="url(#prefix__e)">
          <path
            data-name="MENU copy 5"
            d="M0 604h19.5A16.5 16.5 0 0136 620.5 16.5 16.5 0 0119.5 637H0v-33z"
            fill={primaryColor}
          />
        </g>
        <text
          data-name="September, 2021"
          transform="translate(176.89 108.877)"
          fill={primaryColor}
          fontSize={12}
          fontFamily="OpenSans-SemiBold, Open Sans"
          fontWeight={600}
        >
          <tspan x={-46.667} y={0}>
            {t("mobilePreview.september2021")}
          </tspan>
        </text>
        <circle
          data-name="Ellipse 790"
          cx={13.092}
          cy={13.092}
          r={13.092}
          transform="translate(167 153.877)"
          fill={primaryColor}
        />
        <path
          d="M34.416 104.122l3.54-3.54a1 1 0 10-1.42-1.41l-4.24 4.24a1 1 0 000 1.42l4.24 4.29a1 1 0 101.42-1.41z"
          fill={primaryColor}
        />
        <path
          data-name="angle-right"
          d="M327.704 103.412l-4.24-4.24a1 1 0 00-1.42 1.41l3.54 3.54-3.54 3.54a1 1 0 001.42 1.41l4.24-4.24a1 1 0 000-1.42z"
          fill={primaryColor}
        />
        <path
          d="M38.182 737.724a.818.818 0 10-.818-.818.818.818 0 00.818.818zm4.091 0a.818.818 0 10-.818-.818.818.818 0 00.818.818zm0-3.273a.818.818 0 10-.818-.818.818.818 0 00.818.819zm-4.091 0a.818.818 0 10-.818-.818.818.818 0 00.818.819zm5.727-9.818h-.818v-.818a.818.818 0 00-1.636 0v.818h-6.546v-.818a.818.818 0 10-1.636 0v.818h-.818A2.455 2.455 0 0030 727.088v11.454a2.455 2.455 0 002.455 2.455h11.454a2.455 2.455 0 002.455-2.455v-11.454a2.455 2.455 0 00-2.455-2.455zm.818 13.909a.818.818 0 01-.818.818H32.455a.818.818 0 01-.818-.818v-7.363h13.09zm0-9H31.636v-2.454a.818.818 0 01.818-.818h.818v.818a.818.818 0 001.636 0v-.818h6.545v.818a.818.818 0 001.636 0v-.818h.818a.818.818 0 01.818.818zm-10.636 4.91a.818.818 0 10-.818-.818.818.818 0 00.818.818zm0 3.273a.818.818 0 10-.818-.818.818.818 0 00.818.817z"
          fill={primaryColor}
        />
        <g filter="url(#prefix__f)">
          <rect
            data-name="MENU copy 84"
            width={24}
            height={24}
            rx={12}
            transform="translate(17 574)"
            fill={primaryColor}
          />
        </g>
        <circle
          data-name="Ellipse 33"
          cx={4}
          cy={4}
          r={4}
          transform="translate(55 617)"
          fill={primaryColor}
        />
        <path
          data-name="ellipsis-h"
          d="M298.5 232a2 2 0 102 2 2 2 0 00-2-2zm-7 0a2 2 0 102 2 2 2 0 00-2-2zm14 0a2 2 0 102 2 2 2 0 00-2-2z"
          fill={primaryColor}
        />
        <circle
          data-name="Ellipse 37"
          cx={10}
          cy={10}
          r={10}
          transform="translate(324 224)"
          fill={primaryColor}
        />
        <g fill={textColor}>
          <text
            transform="translate(25 364.443)"
            fontSize={12}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight={700}
          >
            <tspan x={0} y={0}>
              {"A"}
            </tspan>
          </text>
          <path
            data-name="check"
            d="M341.722 357.253a.854.854 0 00-1.212 0l-6.361 6.37-2.67-2.682a.873.873 0 00-1.212 1.255l3.279 3.279a.854.854 0 001.212 0l6.964-6.967a.854.854 0 000-1.255zM341.722 583.253a.854.854 0 00-1.212 0l-6.361 6.37-2.67-2.682a.873.873 0 00-1.212 1.255l3.279 3.279a.854.854 0 001.212 0l6.964-6.967a.854.854 0 000-1.255z"
          />
          <path d="M16 613a8 8 0 108 8 8 8 0 00-8-8zm0 14.4a6.4 6.4 0 116.4-6.4 6.4 6.4 0 01-6.4 6.4zm3.2-7.2h-2.4v-2.4a.8.8 0 10-1.6 0v2.4h-2.4a.8.8 0 000 1.6h2.4v2.4a.8.8 0 101.6 0v-2.4h2.4a.8.8 0 000-1.6z" />
          <text
            data-name={19}
            transform="translate(180 171.877)"
            fontSize={12}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight={700}
          >
            <tspan x={-6.85} y={0}>
              {"19"}
            </tspan>
          </text>
          <path d="M330.727 233.545h-2.182a.545.545 0 00-.545.546v4.364a.545.545 0 00.545.545h2.182a.545.545 0 00.545-.545v-4.364a.545.545 0 00-.545-.546zm-.545 4.364h-1.091v-3.273h1.091zm9.273-6.545h-2.182a.545.545 0 00-.545.545v6.545a.545.545 0 00.545.545h2.182a.545.545 0 00.545-.544v-6.546a.545.545 0 00-.545-.545zm-.545 6.545h-1.092v-5.454h1.091zM335.091 227h-2.182a.545.545 0 00-.545.545v10.91a.545.545 0 00.545.545h2.182a.545.545 0 00.545-.545v-10.91a.545.545 0 00-.545-.545zm-.546 10.909h-1.09v-9.818h1.09z" />
          <text
            data-name="B"
            transform="translate(25 590.443)"
            fontSize={12}
            fontFamily="OpenSans-Bold, Open Sans"
            fontWeight={700}
          >
            <tspan x={0} y={0}>
              {"B"}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

export default MobilePreviewComponent;
